import React from 'react'
import { Modal } from 'antd'

export type FormModalWidth = 'small' | 'medium' | 'large'

const WIDTH_TO_PX: Record<FormModalWidth, number> = {
  small: 420,
  medium: 560,
  large: 800,
}

export interface FormModalProps {
  open: boolean
  title: React.ReactNode
  /** @default 'medium' */
  width?: FormModalWidth
  /** Caller supplies its own action buttons, built from the shared Button component. */
  footer: React.ReactNode
  onClose: () => void
  children: React.ReactNode
}

/**
 * Shared shell for Bucket B of the modals audit (docs/component-audit/modals.html):
 * a bespoke form wrapped in consistent header/footer/loading chrome. Collapses ~10
 * bespoke components (cancel-subscription-modal, modal-forgot-password, etc.) that
 * keep their own field/validation logic - only the surrounding modal is shared.
 */
export function FormModal({ open, title, width = 'medium', footer, onClose, children }: FormModalProps) {
  return (
    <Modal open={open} title={title} width={WIDTH_TO_PX[width]} onCancel={onClose} footer={footer}>
      {children}
    </Modal>
  )
}

export default FormModal
